import { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import { Box, Button, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

type ColorInputProps = {
  handleChange: (color?: string) => void;
};

const ColorInput = ({ handleChange }: ColorInputProps) => {
  const { t } = useTranslation();

  const [color, setColor] = useState<string | undefined>();
  const [inputKey, setInputKey] = useState(Date.now()); // unique key

  useEffect(() => {
    if (color) {
      handleChange(color);
    } else {
      handleChange(undefined);
    }
  }, [color]);

  const clearColor = () => {
    setColor(undefined);
    setInputKey(Date.now()); // trigger re-render of input
  };

  return (
    <Box>
      <Button
        variant="outlined"
        component="label"
        fullWidth
        sx={{ mb: "10px", py: 3, justifyContent: "flex-start", minHeight: 60 }}
        size="large"
        color="inherit"
        endIcon={
          color && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                // Clear the file input
                clearColor();
              }}
              size="small"
            >
              <Close />
            </IconButton>
          )
        }
        startIcon={
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: 0.5,
              bgcolor: color,
              border: "1px solid #ccc",
            }}
          />
        }
      >
        {color ? color : t("Select a color")}
        <input
          key={inputKey} // forces re-creation on key change
          type="color"
          hidden
          onChange={(e) => {
            setColor(e.target.value);
          }}
        />
      </Button>
    </Box>
  );
};

export default ColorInput;
